export class WorkspaceMigrationManagerImpl {
    partnerOrganizationFetcher;
    constructor(partnerOrganizationFetcher) {
        this.partnerOrganizationFetcher = partnerOrganizationFetcher;
    }
    async attachDirectWorkspace(workspaceId) {
        return this.partnerOrganizationFetcher.post([
            'workspaces',
            workspaceId,
            'attach',
        ]);
    }
}
